import React from "react";
import { LOGOS_FOOTER } from "@/assets/images";

// Footer: single combined partner-logos image (LTS · Tonini Finance LTD · NAŠA.com),
// centered and responsive.
export const Footer = ({ testid = "footer-logos" }) => (
  <footer
    data-testid={testid}
    className="flex items-center justify-center pt-2 pb-1"
  >
    <img
      src={LOGOS_FOOTER}
      alt="LTS · Tonini Finance LTD · NAŠA.com"
      style={{ maxWidth: "100%", height: "auto", display: "block" }}
      data-testid="footer-logos-image"
    />
  </footer>
);

export default Footer;
